import { Component, OnInit } from '@angular/core';
import { HeaderVisibilityService } from './services/header-visibility.service';
import { OfflineStorageService } from './services/offline-storage.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { Observable, Subject, takeUntil } from 'rxjs';
import { getStudentApplication } from './store/selectors/account.selector';
import * as fromAccountAction from './store/actions/account.action'
import { AccountService } from './services/account.service';
import { autoLogout } from './store/actions/auth.actions';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  getStudenApplication$: Observable<any>;
  studentApplication: any;

  ngUnsubscribe = new Subject<void>()

  title = 'spearmin-admin';
  showHeader: boolean = true;

  userProfile: any;

  constructor(
    private offlineStorageService: OfflineStorageService,
    private router: Router,
    private store: Store<AppState>,
    private accountService: AccountService,
    private authService: AuthService
  ) {
    this.getStudenApplication$ = this.store.select(getStudentApplication);
  }

  ngOnInit() {
    this.initializeApp();
  }

  async initializeApp(){
    const user = await this.offlineStorageService.getObject('user');
    if(user){
      this.store.dispatch(fromAccountAction.getUserProfile());
    }

    this.getStudenApplication$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.studentApplication = res;
        if (res.details) {
          this.accountService.checkStatus(this.studentApplication?.details?.notes);
        }
      }
    })

    window.addEventListener('auth:timeout', async (e: any) => {
      console.log('auth:timeout', e?.detail);
      const isTimeout = e?.detail;
      const user = await this.offlineStorageService.getObject('user');
      if (isTimeout && user) {
        this.authService.autoLogout();
      }
    });
  }
}
